// Module
var code = "<textarea rows=\"3\" class=\"form-control\" ng-model=\"vm.value\" id=\"field_{{vm.field.id}}\" minlength=\"{{vm.field.min_length}}\" maxlength=\"{{vm.field.max_length}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\" ng-required=\"{{ vm.required ? 'true' : '' }}\"></textarea> ";
// Exports
module.exports = code;